import { Box, Button } from "@mui/material"
import CheckOutlinedIcon from '@mui/icons-material/CheckOutlined'
import BackspaceOutlinedIcon from '@mui/icons-material/BackspaceOutlined'

const estiloBotao = {
    height: '100%',
    width: '100%',
    fontSize: 'clamp(1.5rem, 5vmin, 2.5rem)',
    fontWeight: 600,
    backgroundColor: (theme: any) => theme.palette.personal?.header || '#333',
    color: 'inherit',
    borderRadius: '12px',
    boxShadow: 'none',
    textTransform: 'none',
} as const

interface NumericKeypadProps {
    onDigito: (digito: string) => void
    onApagar: () => void
    onConfirmar: () => void
    apagarDesabilitado?: boolean
    confirmarDesabilitado?: boolean
    desabilitado?: boolean
}

export default function NumericKeypad({ onDigito, onApagar, onConfirmar, apagarDesabilitado = false, confirmarDesabilitado = false, desabilitado = false }: NumericKeypadProps): JSX.Element {
    return (
        <Box
            sx={{
                width: '100%',
                display: 'grid',
                gridTemplateColumns: 'repeat(3, 1fr)',
                gridTemplateRows: 'repeat(4, 1fr)',
                gap: 1.5,
            }}
        >
            {[1, 2, 3, 4, 5, 6, 7, 8, 9].map((num) => (
                <Button
                    key={num}
                    variant="contained"
                    sx={estiloBotao}
                    disabled={desabilitado}
                    onClick={() => onDigito(num.toString())}
                >
                    {num}
                </Button>
            ))}

            <Button
                variant="contained"
                sx={estiloBotao}
                onClick={onApagar}
                disabled={desabilitado || apagarDesabilitado}
            >
                <BackspaceOutlinedIcon fontSize="large" />
            </Button>

            <Button
                variant="contained"
                sx={estiloBotao}
                disabled={desabilitado}
                onClick={() => onDigito('0')}
            >
                0
            </Button>

            <Button
                variant="contained"
                sx={{ ...estiloBotao, backgroundColor: 'primary.main' }}
                disabled={desabilitado || confirmarDesabilitado}
                onClick={onConfirmar}
            >
                <CheckOutlinedIcon fontSize="large" sx={{ color: 'white' }} />
            </Button>
        </Box>
    )
}